












































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Machine} from "@/models/machine";
import {namespace} from "vuex-class";
import DocumentPdfDialogComponent from "@/components/dialog/DocumentPdfDialog.component.vue";
import { RepositoryFactory } from "@/api/RepositoryFactory";
import ImageRepository from "@/api/ImageRepository";
import ChecklistRepository from "@/api/ChecklistRepository";

const MachineStore = namespace('machine');
const ActuatorTypeStore = namespace('actuatorType');
const imageRepository: ImageRepository = RepositoryFactory.get('image');
const checklistRepository: ChecklistRepository = RepositoryFactory.get('checklist');


@Component({
  components: {
    EditMachineComponent: () => import('./../components/EditMachine.component.vue'),
    EditChecklistComponent: () => import('./../components/EditChecklist.component.vue'),
    ImageGalleryComponent: () => import('./dialog/InventoryImageGalleryDialog.component.vue'),
    DocumentPdfDialogComponent: () => import('./dialog/DocumentPdfDialog.component.vue')
  }
})
export default class MachineTableRowComponent extends Vue {

  @MachineStore.Action("updateMachine")
  public updateMachine!: (payload: { machine: Machine }) => Promise<Machine>

  @ActuatorTypeStore.Getter('actuatorTypes')
  public actuatorTypes!: any[];

  /** Zeigt den kanonischen ActuatorType-Namen anstatt des gespeicherten lowerCaseName */
  get actuatorDisplayName(): string {
    if (!this.machine.actuator) return '';
    const found = this.actuatorTypes.find(
      (a) => a.lowerCaseName === this.machine.actuator || a.name === this.machine.actuator
    );
    return found ? found.name : this.machine.actuator;
  }

  @Prop({default: new Machine({})})
  public machine!: Machine;

  @Prop()
  public stationId!: string;

  public imageDialog = false;
  public documentPdfDialog = false;
  public checklistDialog = false;

  public snackbar: boolean = false;
  public snackbarText: string = '';

  public isSelected = false;

  public imageObjects: any[] = [];

  @Prop({default: () => []})
  public selectedRows!: Machine[];

  @Watch('selectedRows', {immediate: true})
  public selectedRowsChanged() {
    this.isSelected = this.selectedRows.find((element: Machine) => element.id === this.machine.id) !== undefined;
  }

  public async editChecklist() {
    const checklist = await checklistRepository.getChecklist(this.machine.id);
    
    this.machine.checklist = checklist.data;
    this.checklistDialog = true;
  }

  public async openImages() {
    const imageObjects = await imageRepository.getImagesByMachine(this.machine.id);
    this.imageObjects = imageObjects.data;
    this.imageDialog = true
  }

  public openDocumentPdf() {
    this.documentPdfDialog = true
  }




  public closeAllDialogs() {
    this.imageDialog = false;
    this.documentPdfDialog = false;
  }

  public async closeChecklistDialog(edited: boolean) {
    if (edited) {
      if (this.machine) {
        await this.updateMachine({machine: this.machine});
      }
      this.snackbar = true;
      this.snackbarText = 'Checklist erfolgreich gespeichert.';
      this.$emit('closing', edited);
    }
    this.checklistDialog = false;
  }

  public selectedCheckbox() {
    if (this.isSelected) {
      const findIndex = this.selectedRows.findIndex(machine => machine.id === this.machine.id);
      this.selectedRows.splice(findIndex, 1);
      this.isSelected = false;
    } else {
      this.selectedRows.push(this.machine);
      this.isSelected = true;
    }
  }
}
